import { ArrowRight, Mail, Play, Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/config/constants';

export function AboutPage() {
  const navigate = useNavigate();

  return (
    <main className="min-h-screen overflow-hidden text-white">
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 -z-10 bg-[linear-gradient(180deg,rgba(10,10,14,0.45),rgba(10,10,14,0.6))] backdrop-blur-[22px] backdrop-saturate-[1.3]"
      />

      <section className="relative px-5 py-12 sm:px-8 lg:px-10">
        <div className="mx-auto grid min-h-[520px] max-w-[1220px] items-center gap-12 lg:grid-cols-[600px_minmax(0,1fr)]">
          <button
            type="button"
            className="about-video-card group relative min-h-[338px] overflow-hidden rounded-[16px] p-8 text-left shadow-[0_30px_90px_rgba(0,0,0,0.35)] sm:min-h-[360px] sm:p-9"
            aria-label="Play WINR overview"
          >
            <div aria-hidden className="about-person-back" />
            <div aria-hidden className="about-person-front" />
            <div aria-hidden className="about-head-front" />
            <div aria-hidden className="about-head-back" />

            <div className="relative z-10 max-w-[330px]">
              <h1 className="m-0 text-[38px] font-black leading-[0.98] tracking-[-1.1px] text-white sm:text-[48px]">
                The future of community is here
              </h1>
              <p className="mt-5 max-w-[250px] text-[15px] font-bold leading-5 text-white/80">
                With WINR guides, operators, and creator-first tools.
              </p>
            </div>

            <span className="absolute bottom-7 left-7 z-10 inline-flex items-center gap-3 text-[17px] font-black text-white transition-transform group-hover:translate-x-1">
              <span className="grid h-10 w-10 place-items-center rounded-full bg-white text-[#16122c] shadow-[0_14px_34px_rgba(0,0,0,0.24)]">
                <Play size={16} fill="currentColor" strokeWidth={0} />
              </span>
              Watch overview
            </span>
          </button>

          <div>
            <p className="mb-4 inline-flex items-center gap-2 text-[12px] font-black uppercase tracking-[0.32em] text-accent">
              <Sparkles size={15} />
              About WINR
            </p>
            <h2 className="m-0 text-[42px] font-black leading-none tracking-[-1px] text-white sm:text-[56px]">
              What is WINR?
            </h2>
            <p className="mt-8 text-[18px] font-black leading-7 text-white">
              WINR is the all-in-one home for your community.
            </p>
            <p className="mt-7 max-w-[560px] text-[19px] font-bold leading-[1.35] text-white/80">
              From branded community spaces to discussions, live rooms, payments, AI-powered
              workflows, and creator monetization, WINR gives you everything you need to build and
              scale a community-led business.
            </p>
            <button
              type="button"
              onClick={() => navigate(ROUTES.home)}
              className="mt-8 inline-flex items-center gap-2 text-[16px] font-black text-white transition-colors hover:text-accent"
            >
              Start building
              <ArrowRight size={18} strokeWidth={2.5} />
            </button>
          </div>
        </div>
      </section>

      <section className="px-5 pb-24 sm:px-8 lg:px-10">
        <div className="mx-auto max-w-[860px] rounded-[28px] border border-white/10 bg-white/[0.055] px-7 py-9 text-center shadow-[0_28px_90px_rgba(0,0,0,0.34)] backdrop-blur-2xl sm:px-12 sm:py-12">
          <div className="mx-auto mb-6 grid h-14 w-14 place-items-center rounded-full bg-white text-black shadow-[0_18px_45px_rgba(0,0,0,0.25)]">
            <Mail size={24} strokeWidth={2.2} />
          </div>
          <p className="text-[12px] font-black uppercase tracking-[0.34em] text-accent">
            Business inquiries
          </p>
          <h3 className="mx-auto mt-4 max-w-[680px] text-[34px] font-black leading-[1.04] tracking-[-0.8px] text-white sm:text-[46px]">
            Partner with WINR.
          </h3>
          <p className="mx-auto mt-5 max-w-[620px] text-[16px] font-semibold leading-7 text-white/70">
            For partnerships, brand opportunities, creator programs, and business inquiries,
            contact the WINR team directly.
          </p>
          <a
            href="mailto:admin@joinwinr.com"
            className="mt-8 inline-flex items-center gap-3 text-[20px] font-black tracking-[-0.3px] text-white transition-colors hover:text-accent"
          >
            admin@joinwinr.com
            <ArrowRight size={19} strokeWidth={2.5} />
          </a>
        </div>
      </section>
    </main>
  );
}
